const API_URLS = {
    // -------------Auth---------------

    LOGIN: "/Auth/Login",
    RERESH_TOKEN: "/Auth/RefreshToken",
    LOGOUT_USER: "/Auth/LogOut",
    VERIFY_OTP: "/Auth/VerifyOtp",

    // -------------Regions---------------

    INSERT_REGIONS: "/Regions/InsertRegion",
    GET_REGIONS: "/Regions/GetRegions?isActive=true",

    // -------------Regions---------------

    INSERT_ADMINS: "/AdminUser/InsertAdminUser",
    GET_ADMINS: "/AdminUser/GetAdminUsers?",

    // -------------Clinic Domain---------------

    INSERT_CLINIC_DOMAIN: "/ClinicDomains/InsertClinicDomain",
    GET_CLINIC_DOMAINS: "/ClinicDomains/GetClinicDomains?",

    // --------------------------admin user------------------
    ADMIN_USER_DELETE: "/AdminUser/DeleteAdminUser?id=",
    ADMIN_USER_ADD: "/AdminUser/InsertAdminUser",
    GET_ADMIN_USER_BY_ID: "/AdminUser/GetAdminUserById?ID=",
    UPDATE_ADMIN_USER: "/AdminUser/UpdateAdminUser",

    // ----------------------clinic---------------------
    INSERT_CLINIC: "/Clinic/InsertClinic",
    UPDATE_CLINIC: "/Clinic/UpdateClinic",
    DELETE_CLINIC: "/Clinic/DeleteClinic?masterClinicId=",
    GET_CLINIC_BY_ID: "/Clinic/GetClinicById?masterClinicId=",
    GET_CLINIC_BY_REGION: "/Clinic/GetAllClinicByRegion",
    UPDATE_CLINIC_STATUS: "/Clinic/UpdateClinicStatus",
    IS_DUPLICATE_DOMAIN_IN_CLINIC:
        "/Clinic/IsDuplicateDomainInClinic?domainName=",
    GET_DOCUMENT_TEMPLATES_BY_CLINIC: "/Document/GetDocumentTemplatesByClinic?",
    SEARCH_DOCUMENT_TEMPLATE_BY_NAME: "/Document/SearchDocumentTemplateByName?",
    GET_CLINIC_INFO: "/Clinic/GetClinicByClinicId",
    UPDATE_CLINIC_COMMENT: '/clinic/UpdateClinicComment',
    GET_CLINIC_TEMPLATE_INFO: "/Clinic/GetClinicDocumentTotalByMonth",
    GET_CLINIC_BILLING_INFO: "/Clinic/GetClinicBilling837TotalByMonth",
    GET_CLINIC_CONTACT_INFO: "/Clinic/GetClinicContactPersons",
    DELETE_CLINIC_CONTACT: "/Clinic/DeleteClinicContactPerson",
    GET_CLINIC_CONTACT_INFO_BY_ID: "/Clinic/GetClinicContactPersonsById",
    INSERT_CLINIC_CONTACT: "/Clinic/InsertClinicContactPersons",
    GET_CLINIC_SMS_USAGE: "/Clinic/GetClinicSmsUsage",
    // Twilio SMS lookup (admin support tool)
    GET_SMS_TWILIO_LOOKUP: "/Clinic/GetPhoneMessageHistory",
    UPDATE_CLINIC_CONTACT: "/Clinic/UpdateClinicContactPersons",
    GET_ALL_PLACE_OF_SERVICETYPE: "/Common/GetAllPlaceOfServiceType",
    GET_TIME_RECORDING_METHODS: "/Common/GetTimeRecordingMethods",
    GET_DOCUMENT_TEMPLATE_PREFS_BY_TEMPLATE_ID: "/Document/GetDocumentTemplatePrefsByTemplateId",
    INSERT_OR_UPDATE_DOCUMENT_TEMPLATE_PREF: "/Document/InsertOrUpdateDocumentTemplatePref",
    DELETE_TEMPLATE: "/api/Document/DeleteTemplate",
    GET_STRIPE_CUSTOMER_INFO: "/SubscriptionManager/GetStripeCustomer",
    GET_STRIPE_PRODUCTS: "/SubscriptionManager/GetStripeProducts",
    GET_PRODUCTS_PRICE: "/SubscriptionManager/GetStripeProductPrices",

    // ----------------------Client---------------------
    ALL_CLINIC: "/Clinic/GetAllClinics?isActive=true",
    SEARCH_CLIENT: "/Client/SearchClient",
    ALL_CLINIC_BY_ACTIVE: "/Clinic/GetAllClinics?isActive=",

    // -----------------------Roles---------------------
    GET_ROLES: "/Common/GetRole?regionId=",
    GET_ROLE_MODULE_PERMISSION_ACCESS:
        "/Common/GetRoleModulePermissionAccess?roleId=",
    UPDATE_ROLE_PERMISSION: "/Common/UpdateRoleModulePermissionAccess",

    // ----------------------------Staff-----------------------
    GET_STAFF: "/Staff/GetStaff",
    ADD_STAFF: "/Staff/AddStaff",
    UPDATE_STAFF: "/Staff/UpdateStaff",
    GET_STAFF_BY_ID: "/Staff/GetStaffById?id=",
    IMPERSONATE_STAFF: "/Impersonate/ImpersonateStaff",
    IMPERSONATE_CLIENT: "/Impersonate/ImpersonateClient",

    // --------------------Common-------------------------
    UPLOAD_FILE: "/Common/UploadIcdFile",
    ROLES: "/Common/GetRole?regionId=",
    TIMEZONE: "/Common/GetTimeZones?regionId=",
    GENDER: "/Common/GetGenders?regionId=",
    GET_DOCUMENT_TEMPLATE_LABELS: "/Common/GetDocumentTemplateLabels?regionId=",
    IMPORT_EOB_FILE: "/Import/Add835ImportRequest",

    // -----------------------------------------Admin File Document template----------------------------
    DOCUMENT_TEMPLATE_TYPE: "/Document/GetDocumentTemplateTypes?regionId=",
    INSERT_DOCUMENT_TEMPLATE: "/Document/InsertDocumentTemplates",
    GET_ALL_ADMIN_CLINIC: "/Clinic/GetAdminClinic?region=",
    ASSIGN_TEMPLATE_TO_CLINIC: "/Document/AssignTemplateToClinic",
    UNASSIGN_DOCUMENT_TEMPLATE: "/Document/UnAssignTemplateFromClinic?regionId=",
    GET_ADMIN_DOCUMENTS: "/Document/GetAdminDocuments?regionId=",
    GET_MARK_DOCUMENT_TEMPLATE_AS_DEFAULT:
        "/Document/MarkDocumentTemplateAsDefault?regionId=",
    GET_ALL_CLINIC_BY_REGION: "/Clinic/GetAllClinicByRegion?region=",
    GET_ALL_DEFAULT_DOCUMENT_TEMPLATES:
        "/Document/GetAllDefaultDocumentTemplates?regionId=",
    COPY_DOCUMENT_TEMPLATE_TO_REGION: "/Document/CopyDocumentTemplateToRegion",
    POST_ASSIGN_LABEL_TO_DOCUMENT_TEMPLATE: "/Document/AssignLabelToDocumentTemplate",
    UPDATE_DOCUMENT_TEMPLATE: "/Document/UpdateDocumentTemplate",
    INSERT_UPDATE_DOCUMENT_TEMPLATE_LABEL: "/Common/InsertUpdateDocumentTemplateLabel",
    DELETE_DOCUMENT_TEMPLATE_LABEL: "/Common/DeleteDocumentTemplateLabel?id=",

    //----------------------------------------------Data Import-----------------------------------------
    GET_ALL_DATA_IMPORT_QUEUE_ITEMS: "/Import/GetImportQueueData?region=",
    ADD_IMPORT_REQUEST: "/Import/AddImportRequest",
    ADD_IMPORT_FILE_REQUEST: "/Import/AddImportFileRequest",

    //----------------------------------------------DASHBOARD-----------------------------------------
    GET_ALL_ONLINE_STAFFCOUNT: "/DashBoard/GetAllOnlineStaffCount",
    GET_ALL_CLINIC_COUNT: "/DashBoard/GetAllClinicCount",
    GET_ALL_STAFF_COUNT: "/DashBoard/GetAllStaffCount",
    GET_ALL_CLIENTS_COUNT: "/DashBoard/GetAllClientsCount",
    GET_ALL_CLINIC_COUNT: "/DashBoard/GetAllClinicCount",
    GET_ALL_STAFF_COUNT: "/DashBoard/GetAllStaffCount",
    GET_835BILLING_COUNT: "/DashBoard/Get835BillingTotAmt",
    GET_837BILLING_COUNT: "/DashBoard/Get837BillingTotAmt",
    GET_BILLING_CLAIM_COUNT: "/DashBoard/GetClaimsBilledTotAmt",

    //------------------------------------Staff Plan Document Template----------------------------------------------------------
    GET_STAFF_DOCUMENT_TEMPLATE: "/StaffTemplate/GetAllStaffPlanTemplates?regionId=",
    INSERT_UPDATE_STAFF_DOCUMENT_TEMPLATE: "/StaffTemplate/InsertUpdateStaffPlanTemplates",
    ASSIGN_STAFF_TEMPLATE_TO_CLINIC: "/StaffTemplate/AssginStaffPlanTemplate",
    POST_ASSIGN_LABEL_TO_STAFF_TEMPLATE: "/StaffTemplate/AssignLabelToStaffPlanTemplate",
    DELETE_ASSIGN_STAFF_PLAN_TEMPLATE: "/StaffTemplate/RemoveClinicAccessOfStaffPlanTemplate?regionId=",
    COPY_STAFF_PLAN_TEMPLATE_TO_REGION: "/StaffTemplate/CopyStaffPlanTemplateToOtherRegion",
    SEND_STAFF_WELCOME_EMAILS: "/Staff/SendStaffWelcomeEmails",

    //------------------------------------Training Links----------------------------------------------------------
    INSERT_TRAINING_LINK: "/TrainingLink/InsertTrainingLink",
    GET_TRAINING_LINKS: "/TrainingLink/GetTrainingLinks",
    DELETE_TRAINING_LINK: "/TrainingLink/DeleteTrainingLink?trainingLinkId=",
    UPDATE_TRAINING_LINK: "/TrainingLink/UpdateTrainingLink",
    //------------------------------------Logs----------------------------------------------------------
    GET_LOGS: "/Logs/GetLogs",
    GET_CLOUDWATCH_LOGS: "/Logs/GetCloudWatchLogs",

    GET_ALL_CLINIC_STATES: "/Common/GetStates",

    // ----------------------------Subpoena -----------------------------------
    INSERT_UPDATE_SUBPOENA_REQUEST: "/Clinic/InsertUpdateSubpoenaRequest",
    GET_SUBPOENA_REQUEST: "/Clinic/GetSubpoenaRequest",
    GET_SUBPOENA_REQUEST_BY_ID: "/Clinic/GetSubpoenaRequestById",
    UPDATE_SUBPOENA_REQUEST_STATUS: "/Clinic/UpdateSubpoenaRequestStatus",
    DELETE_SUBPOENA_REQUEST: "/Clinic/DeleteSubpoenaRequest",
    GET_SUBPOENA_MODULES: "/Clinic/GetSubpoenaModules",
    SEND_SUBPOENA_LINK_EMAIL: "/Clinic/SendSubpoenaLinkEmail",
    GET_SUBPOENA_REQUEST_ZIP_URL: "/Clinic/GetSubpoenaRequestZipUrl",

    UPDATE_STRIPE_CUSTOMER_ID: "/Clinic/UpdateStripeCustomerId",

    GET_CUSTOMER_STATUSES: "/Clinic/GetCustomerStatuses",
    UPDATE_CUSTOMER_STATUSES: "/Clinic/BulkUpdateCustomerStatus",

    // ----------------------------Announcement-------------------------------------------
    INSERT_ANNOUNCEMENT: "/Announcement/InsertAnnouncement",
    UPDATE_ANNOUNCEMENT: "/Announcement/UpdateAnnouncement",
    GET_ANNOUNCEMENTS: "/Announcement/GetAnnouncement",
    GET_ANNOUNCEMENT_BY_ID: "/Announcement/GetAnnouncementById",
    DELETE_ANNOUNCEMENT: "/Announcement/DeleteAnnouncement",
    INSERT_BAA: "/Announcement/InsertBaa",
    GET_BAA: "/Announcement/GetBaa",
    UPDATE_BAA_DATES: "/Announcement/UpdateBaaDates",
    Get_Baa_Acknowledgement_By_Clinic_Id: "/Announcement/GetBaaAcknowledgementByClinicId?masterClinicId=",
    GET_BAA_ACKNOWLEDGEMENT_HISTORY: "/Announcement/GetBaaAcknowledgementHistory",
    // ----------------------------SERVICES-------------------------------------------
    COPY_SERVICES: "/Import/CopyServices",

     // ----------------------------DOCUMENT-------------------------------------------
    GET_S3_SIGNED_URL: "/Document/GetS3FileUploadPreSignedUrl",
    GET_S3_TEMPLATE_SIGNED_URL: "/Document/GetS3TemplateFileUploadPreSignedUrl",
    GET_USER_SEATS_HISTORY: "/Dashboard/GetStaffUserSeatsHistoryReport?",
    GET_AI_DOC_TEMPLATE_MOCKUP_SIGNED_URL: "/Document/GetDocumentTemplateMockupFileUploadPreSignedUrl",
    GET_ALL_AI_DOCUMENT_FILES: "/Document/GetAllAIDocumentFiles",
    DELETE_AI_DOC_TEMPLATE_FILE: "/Document/DeleteDocumentTemplateMockupFile",
    TRIGGER_LAMBDA_PROCESSING: "/Document/TriggerLambdaProcessing",

};

export default API_URLS;
